import * as yup from "yup";
import { validatePhoneNumber } from "@shared/utils/yup-extensions";

export const userBrandingFormSchema = yup.object().shape({
  agentName: yup
    .string()
    .trim()
    .max(150, "Maximum of 150 characters")
    .optional()
    .nullable()
    .label("Agent Name"),

  agentEmail: yup
    .string()
    .trim()
    .email("Invalid email")
    .max(200, "Maximum of 200 characters")
    .optional()
    .nullable()
    .label("Agent Email"),

  agentTitle: yup
    .string()
    .trim()
    .max(100, "Maximum of 100 characters")
    .optional()
    .nullable()
    .label("Agent Title"),

  agentAvatar: yup
    .string()
    .trim()
    .url("Invalid URL")
    .max(200, "Maximum of 200 characters")
    .optional()
    .nullable()
    .label("Agent Avatar"),

  agentMlsId: yup
    .string()
    .trim()
    .max(30, "Maximum of 30 characters")
    .optional()
    .nullable()
    .label("MLS ID"),

  agentPhoneNumber: yup
    .string()
    .test(
      validatePhoneNumber({
        message: "Invalid phone number",
        region: "US",
        optional: true,
      })
    )
    .max(20, "Maximum of 20 characters")
    .optional()
    .nullable()
    .label("Agent Phone Number"),

  officeName: yup
    .string()
    .trim()
    .max(100, "Maximum of 100 characters")
    .optional()
    .nullable()
    .label("Brokerage Name"),

  officeLogo: yup
    .string()
    .trim()
    .url("Invalid URL")
    .max(200, "Maximum of 200 characters")
    .optional()
    .nullable()
    .label("Office Logo"),

  website: yup
    .string()
    .trim()
    .url("Invalid URL")
    .max(200, "Maximum of 200 characters")
    .optional()
    .nullable()
    .label("Website"),

  teamName: yup
    .string()
    .trim()
    .max(100, "Maximum of 100 characters")
    .optional()
    .nullable()
    .label("Team Name"),

  teamLogo: yup
    .string()
    .trim()
    .url("Invalid URL")
    .max(200, "Maximum of 200 characters")
    .optional()
    .nullable()
    .label("Team Logo"),

  instagramUrl: yup
    .string()
    .trim()
    .url("Invalid URL")
    .max(200, "Maximum of 200 characters")
    .optional()
    .nullable()
    .label("Instagram URL"),

  facebookUrl: yup
    .string()
    .trim()
    .url("Invalid URL")
    .max(200, "Maximum of 200 characters")
    .optional()
    .nullable()
    .label("Facebook URL"),

  xUrl: yup
    .string()
    .trim()
    .url("Invalid URL")
    .max(200, "Maximum of 200 characters")
    .optional()
    .nullable()
    .label("X (Twitter) URL"),

  youtubeUrl: yup
    .string()
    .trim()
    .url("Invalid URL")
    .max(200, "Maximum of 200 characters")
    .optional()
    .nullable()
    .label("YouTube URL"),

  linkedInUrl: yup
    .string()
    .trim()
    .url("Invalid URL")
    .max(200, "Maximum of 200 characters")
    .optional()
    .nullable()
    .label("LinkedIn URL"),
});

export type UserBrandingSchema = typeof userBrandingFormSchema.__outputType;
